(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newcore-carousel-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-newcore-carousel]').forEach(function (root) {
      var slides = Array.from(root.querySelectorAll('.newcore-carousel__slide'));
      var dotGroups = Array.from(root.querySelectorAll('.newcore-carousel__dots'));
      var current = 0;
      var timer = null;
      var delay = 5000;

      function syncDots() {
        dotGroups.forEach(function (group) {
          Array.from(group.children).forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === current);
          });
        });
      }

      function show(index) {
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');

        current = (index + slides.length) % slides.length;

        slides[current].classList.add('is-active');
        slides[current].removeAttribute('aria-hidden');
        syncDots();
      }

      function next() {
        show(current + 1);
      }

      function restart() {
        if (timer) clearInterval(timer);
        timer = setInterval(next, delay);
      }

      root.querySelectorAll('.newcore-carousel__dot').forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(parseInt(dot.dataset.dotIndex, 10));
          restart();
        });
      });

      root.querySelectorAll('[data-carousel-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          next();
          restart();
        });
      });

      root.querySelectorAll('[data-carousel-prev]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          show(current - 1);
          restart();
        });
      });

      if (slides.length > 1) {
        restart();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
